import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import placeholder from '../img/placeholder.png';

import CommunityPopup from "./CommunityPopup";

import './ExploreCommunity.css'

const ExploreEvent = ({ events }) => {

    let navigate = useNavigate()

    const [pageNumber, setPageNumber] = useState(0)

    const goToEventPage = (eventId) => {
        navigate(`/event/${eventId}`)
    }


    return (
        <div>
            <Row xs={'auto'} className="communities-container d-flex justify-content-center">
                {events && events.map((val) => {
                    return (
                        <div className='card-col'>
                            <Col>
                                <div className="card-container">
                                    {/* <Card className="explore-card" style={{ width: '18rem', marginBottom: '2vh', marginTop: '2vh' }} onClick={() => { goToEventPage(val._id) }} data-testid="events-card-test-id">
                                        <Card.Img variant="top" src="https://images.pexels.com/photos/9365604/pexels-photo-9365604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />
                                        <Card.Body>
                                            <Card.Title>{val.name}</Card.Title>
                                        </Card.Body>
                                    </Card> */}
                                    <Card sx={{ width: 225 }} onClick={() => { goToEventPage(val._id) }} className="explore-card" data-testid="events-card-test-id">
                                        <CardMedia
                                            component="img"
                                            height="100"
                                            image={val.image ? val.image : placeholder}
                                        />
                                        <CardContent>
                                            <Typography style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} gutterBottom variant="h7" component="div">
                                                {val.name}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </div>
                            </Col>
                        </div>
                    )
                })}
            </Row>
        </div>
    )

}

export default ExploreEvent;